import { render, staticRenderFns } from "./PhrCodePage.vue?vue&type=template&id=9474dccc&scoped=true&"
import script from "./PhrCodePage.vue?vue&type=script&lang=js&"
export * from "./PhrCodePage.vue?vue&type=script&lang=js&"
import style0 from "./PhrCodePage.vue?vue&type=style&index=0&id=9474dccc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9474dccc",
  null
  
)

export default component.exports